module.exports = __webpack_public_path__ + "static/media/password-icon.720172e6.svg";